"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const constants_1 = __importDefault(require("@/constants"));
const CancelSubscriptionModal = ({ onModalClose, onSubscriptionCanceled }) => (react_1.default.createElement(components_1.BaseModal, { title: constants_1.default.cancelSubscriptionModal.areYouSure, content: constants_1.default.cancelSubscriptionModal.youWillRetainAccess, onModalClose: onModalClose, primaryButton: {
        title: constants_1.default.cancelSubscriptionModal.cancelSubscription,
        onClick: onSubscriptionCanceled,
    }, secondaryButton: {
        title: constants_1.default.general.cancel,
        onClick: onModalClose,
    } }));
exports.default = CancelSubscriptionModal;
